import { Pipe, PipeTransform } from '@angular/core';
import { BigNumber } from 'ethers'

@Pipe({name: 'formatDate'})
export class FormatDatePipe implements PipeTransform {
  transform(value: BigNumber): string {
    return new Date(value.mul(1000).toNumber()).toUTCString();
  }
}
